import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";

import IconButton from "shared/react_components/IconButton";

import PhrasesSpokenModal from "./PhrasesSpokenModal";

const PhrasesSpoken = ({ phrasesSpoken }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = useCallback(() => setIsModalOpen(val => !val), []);

  return (
    <React.Fragment>
      <IconButton
        icon="list"
        onClick={toggleModal}
        style={{ marginLeft: -10 }}
      />
      <PhrasesSpokenModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        phrasesSpoken={phrasesSpoken}
      />
    </React.Fragment>
  );
};

PhrasesSpoken.propTypes = {
  phrasesSpoken: PropTypes.array.isRequired
};

export default PhrasesSpoken;
